import _useMount from 'react-use/esm/useMount';

import {UseMount} from './types';
import utils from '@utils';

export const useMount: UseMount = (
  props,
  actions,
  setLoading,
  setIsNotFoundModal
) => {
  _useMount(async () => {
    try {
      utils.scroll.top();

      await actions.notifications.getOneNotification({
        teamId: props.me.teamId,
        notificationId: props.match.params.id,
      });
      await actions.notifications.updateCurrentNotificationDetail({
        notificationId: props.match.params.id,
        page: 1,
        sort: '-replyDatetime',
      });
    } catch (error) {
      switch (error.response.data.message) {
        case 'notification not found':
          setIsNotFoundModal(true);
          break;

        default:
          break;
      }
    } finally {
      actions.notifications.clearDetailSearch();

      setLoading(false);
    }
  });
};
